// PRD 13 §4.1 / §5 — colored status pill.
//   PUBLISHED → green  (badge-success)
//   DRAFT     → yellow (badge-warning)
//   HIDDEN    → gray   (badge-gray)

import { useTranslation } from 'react-i18next';

import type { NoticeStatus } from '../types/notices.types';

const VARIANT_CLASS: Record<NoticeStatus, string> = {
  PUBLISHED: 'badge-success',
  DRAFT: 'badge-warning',
  HIDDEN: 'badge-gray',
};

interface NoticeStatusBadgeProps {
  status: NoticeStatus;
}

export function NoticeStatusBadge({ status }: NoticeStatusBadgeProps) {
  const { t } = useTranslation('notices');
  return <span className={`badge ${VARIANT_CLASS[status]}`}>{t(`statuses.${status}`)}</span>;
}
